import { queryKeys } from '@/lib/query-client';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getJobTabCounts } from '../api/jobListApi';

export function useJobTabCounts(): { counts: Record<string, number> } {
  const { data } = useQuery({
    queryKey: queryKeys.jobs.counts(),
    queryFn: getJobTabCounts,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });

  return { counts: data?.counts ?? {} };
}
